
import { ProfessionData } from '../types/professionTypes';

export const menuisier: ProfessionData = {
  title: "Menuisier",
  slug: "menuisier",
  description: "Solutions de valorisation des déchets de menuiserie",
  icon: "Hammer",
  heroImage: "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png",
  wasteMaterials: [
    {
      type: "Déchets de bois",
      description: "Chutes de bois massif, panneaux et copeaux représentent une ressource valorisable.",
      solutions: ["Tri par catégories", "Valorisation en biomasse"],
      environmentalBenefit: "Production énergie renouvelable et économie forêts"
    },
    {
      type: "Panneaux composites",
      description: "MDF, aggloméré et autres panneaux composites nécessitant un traitement adapté.",
      solutions: ["Broyage et recyclage", "Collecte en big bag"],
      environmentalBenefit: "Réutilisation en nouveaux panneaux"
    },
    {
      type: "Déchets chimiques",
      description: "Vernis, colles, solvants et autres produits chimiques utilisés en menuiserie.",
      solutions: ["Collecte sécurisée", "Traitement spécialisé"],
      environmentalBenefit: "Neutralisation substances dangereuses"
    }
  ],
  relatedProfessions: ["charpentier", "ebeniste", "couvreur"]
};
